import React, { Component } from "react";

class ExtensionHeaders extends Component {
  render() {
    return (
      <table cellSpacing="0" cellPadding="0" className="tablesorter">
        <tbody>
          <tr>
            <th className="table-top-header-left">
              <p>
                <span>Header key</span>
              </p>
            </th>
            <th className="table-top-header-right">
              <p>
                <span>Description</span>
              </p>
            </th>
          </tr>
          <tr>
            <td className="table-inner-header-left">
              <p>
                <span>x-chkp-extension-key</span>
              </p>
            </td>
            <td className="table-inner-header-right">
              <p>
                <span>
                  This value can be used to verify which client accessed your
                  service.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default ExtensionHeaders;
